import { render, staticRenderFns } from "./Site-header.vue?vue&type=template&id=00db0f84"
import script from "./Site-header.vue?vue&type=script&lang=js"
export * from "./Site-header.vue?vue&type=script&lang=js"
import style0 from "./Site-header.vue?vue&type=style&index=0&id=00db0f84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports